import React from 'react';
import { Link } from 'react-router-dom';

export const NavbarLink = ({ title, to }) => (
  <Link 
    to={`${process.env.PUBLIC_URL}${to}`}
    className='
      hover:text-slate-300
      py-2
      px-2 
      border 
      border-600-white
      text-center
      flex-auto
    '>{title}</Link>
);